// flag if the config fields represents a service
// (this is needed as we currently mix services and other settings in our global config)
const serviceConfig = {
  stage: false,
  monolithUrl: false,
  angularUrl: false,
  monolithApiUrl: true,
  organisationService: true,
  iipService: true,
  organisationRegistration: true,
  capacityManagement: true,
  authentication: false,
  surrenderService: true,
  contractManagement: true,
  documentExchange: true,
  gasDataManagement: true,
  snamBidCollector: true,
  transparencyReporting: true,
  directFcfs: true,
  regularFcfs: true,
  hydrogenFcfs: true,
  remitReporting: true,
  lngOperators: false,
  networkPoints: true,
  authorizationService: true,
  lngMarketing: true,
  assignmentService: true,
  transportAuction: true,
  exchangerateService: true,
  secondaryMarketService: true,
  superBundleService: true,
  mapPrototype: true, // ! Implementation for the Map Prototype
  ttpcModulationService: true,
  notificationService: true,
} satisfies Record<keyof typeof PRISMA_CONFIG, boolean>;

type ServiceConfig = typeof serviceConfig;
type ServiceConfigKeys = keyof ServiceConfig;

export type Service = {
  [K in ServiceConfigKeys]: ServiceConfig[K] extends true ? K : never;
}[ServiceConfigKeys];

export const services = Object.entries(serviceConfig).reduce(
  (acc, [key, value]) => (value ? [...acc, key as Service] : acc),
  [] as Service[]
);

export const teams = {
  Carma: 'Carma',
  Rupert: 'Rupert',
  Otter: 'Otter',
  Goat: 'Goat',
  Ontec: 'Ontec',
  Lynx: 'Lynx',
} as const;

export const ownershipMapper = {
  assignmentService: teams.Rupert,
  authorizationService: teams.Carma,
  capacityManagement: teams.Carma,
  contractManagement: teams.Rupert,
  directFcfs: teams.Ontec,
  documentExchange: teams.Rupert,
  gasDataManagement: teams.Ontec,
  iipService: teams.Carma,
  lngMarketing: teams.Rupert,
  monolithApiUrl: teams.Goat,
  networkPoints: teams.Otter,
  organisationRegistration: teams.Rupert,
  organisationService: teams.Rupert,
  regularFcfs: teams.Ontec,
  hydrogenFcfs: teams.Ontec,
  remitReporting: teams.Ontec,
  snamBidCollector: teams.Goat,
  surrenderService: teams.Carma,
  transparencyReporting: teams.Ontec,
  transportAuction: teams.Otter,
  exchangerateService: teams.Ontec,
  secondaryMarketService: teams.Carma,
  superBundleService: teams.Rupert,
  ttpcModulationService: teams.Carma,
  mapPrototype: teams.Carma, // ! Implementation for the Map Prototype
  notificationService: teams.Rupert,
} as const satisfies Record<Service, string>;
